import { twClassMerge } from '@healthhub/react-ui';
import { Typography } from 'antd';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { EmptyRecord } from '@shared/assets';

export interface CommonEmptyStateScreenProps {
  className?: string;
  contactMessage?: string;
  emptyImg?: string;
  hidePhoneNumber?: boolean;
  message?: ReactNode | string;
  showContact?: boolean;
}

const { Link, Text } = Typography;

const CommonEmptyStateScreen = ({
  className,
  contactMessage,
  emptyImg = EmptyRecord,
  hidePhoneNumber,
  message,
  showContact,
}: CommonEmptyStateScreenProps) => {
  const { t } = useTranslation();

  return (
    <div className={twClassMerge('flex flex-col items-center pt-16', className)}>
      <img alt="" className="my-8 w-fit" src={emptyImg} />
      <div className="flex max-w-[500px] flex-col text-center">
        {typeof message === 'string' ? (
          <Text className="mb-5 inline-block text-base font-semibold">{message}</Text>
        ) : (
          message
        )}
        {!!showContact && (
          <Text className="text-sm block px-4">
            {contactMessage || t('emptyState.help')}{' '}
            {!hidePhoneNumber && (
              <>
                <Link className="font-semibold text-theme-600" href="tel:18002254482">
                  1800 225 4482
                </Link>{' '}
                or{' '}
              </>
            )}
            <Link className="font-semibold text-theme-600" href="mailto:contact_us@healthhub.sg">
              contact_us@healthhub.sg
            </Link>
          </Text>
        )}
      </div>
    </div>
  );
};

export default CommonEmptyStateScreen;
